const map = {
	"./building-career-in-tech.js": 808,
	"./farms-to-code.js": 739,
	"./idea-to-app-store.js": 599,
	"./index.js": 198,
	"./lingua-playlist.js": 57,
	"./living-in-china.js": 751
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;